module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DatabaseSearch-results"
  }, [(!!_vm.results.length) ? _c('p', {
    staticClass: "DatabaseSearch-results-count"
  }, [_vm._v("Showing " + _vm._s(_vm.results.length) + " of " + _vm._s(_vm.totalCount) + " Results")]) : _vm._e(), _vm._v(" "), (!!_vm.results.length) ? _c('ol', {
    staticClass: "ListingGrid u-mt2"
  }, _vm._l((_vm.results), function(item, index) {
    return _c('li', {
      staticClass: "ListingGrid-item"
    }, [(item.node.type === 'Person') ? _c('result', {
      attrs: {
        "label": "Person",
        "path": item.node.path,
        "title": item.node.full_name,
        "meta": 'Party: ' + item.node.party_name
      }
    }) : _vm._e(), _vm._v(" "), (item.node.type === 'District') ? _c('result', {
      attrs: {
        "label": "District",
        "path": item.node.path,
        "title": item.node.name,
        "meta": item.node.state_name
      }
    }) : _vm._e(), _vm._v(" "), (item.node.type === 'Election') ? _c('result', {
      attrs: {
        "label": "Election",
        "path": item.node.path,
        "title": item.node.name,
        "meta": item.node.year
      }
    }) : _vm._e()], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.hasNextPage) ? _c('div', {
    staticClass: "u-center u-mt4"
  }, [_c('button', {
    staticClass: "Button Button--outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('databaseSearch/getNextResults')
      }
    }
  }, [_vm._v("\n      Load More\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "DatabaseSearch-loading"
  }, [(_vm.searching && !!_vm.cursor) ? _c('div', {
    staticClass: "DatabaseSearch-spinner"
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0641f7e8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/database-search/results.vue
// module id = 315
// module chunks = 0